import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { BusinessSetupChatMessage } from '../composables/use-business-setup-agent'

export const useBooksyAssistantStore = defineStore('booksy-assistant', () => {
  const isOpen = ref(false)
  const messages = ref<BusinessSetupChatMessage[]>([])
  const isSending = ref(false)
  const sessionId = ref<string | null>(null)
  const error = ref<string | null>(null)
  const draft = ref('')
  const voiceAutoSend = ref(false)
  const restoredUserId = ref<string | number | null>(null)

  return {
    isOpen,
    messages,
    isSending,
    sessionId,
    error,
    draft,
    voiceAutoSend,
    restoredUserId,
  }
})
